import { useDispatch } from "react-redux";
import { updateWatchlist } from "../redux/reducers/userSlice";
import userServices from "../services/userServices";


export const getMyWatchlist = async (dispatch) => {
    const res = await userServices.getMyWatchlist();
    if (res && res.success && res.data?.length > 0) {
        dispatch(updateWatchlist(res.data));
    }
    else{
        dispatch(updateWatchlist([]));
    }
}
